export const Connect = window.Connect
export const token = process.env.REACT_APP_TOKEN_CALL_ME_BACK
export const DEFAULT_PHONE_NUMBER = '900897016'
